import React, { useState } from "react";
import { AddIcon } from "../../assets/icons/icons";

export default function AddCoupon() {
    const [formData, setFormData] = useState({
        coupon_name: '',
        coupon_code: '',
        coupon_discount: '',
        coupon_start_date: '',
        coupon_end_date: ''
    });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: undefined
            }));
        }
    };
   
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setErrors({});
        setSuccessMessage('');

        try {
            const token = sessionStorage.getItem("authToken");
            const response = await fetch('https://laravel-api.aj-mart.com/api/coupon/add', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                     Authorization: `Bearer ${token}`
                    // 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (!response.ok) {
                if (response.status === 422) {
                    setErrors(data.errors || {});
                } else {
                    throw new Error(data.message || 'Something went wrong');
                }
                return;
            }

            if (data.success) {
                setSuccessMessage(data.message);
                handleReset();
            } else {
                throw new Error(data.message || 'Failed to create coupon');
            }
        } catch (error) {
            console.error('Error:', error);
            setErrors({ 
                general: Array.isArray(error.message) 
                    ? error.message 
                    : [error.message || 'An unexpected error occurred']
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleReset = () => {
        setFormData({
            coupon_name: '',
            coupon_code: '',
            coupon_discount: '',
            coupon_start_date: '',
            coupon_end_date: ''
        });
        setErrors({});
    };

    const renderError = (fieldName) => {
        const error = errors[fieldName];
        if (!error) return null;
        
        return (
            <p className="text-red-500 text-sm mt-1">
                {Array.isArray(error) ? error[0] : error}
            </p>
        );
    };

    return (
        <section className="py-[25px] flex flex-col gap-[15px]">
            <div className="main-title mb-[20px]">Add Coupon</div>
            <div className="max-w-3xl">
                {successMessage && (
                    <div className="mb-4 p-4 bg-green-50 border border-green-200 text-green-600 rounded-md">
                        {successMessage}
                    </div>
                )}

                {errors.general && (
                    <div className="mb-4 p-4 bg-red-50 border border-red-200 text-red-600 rounded-md">
                        {Array.isArray(errors.general) ? errors.general[0] : errors.general}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="flex flex-col gap-[10px]">
                        <div className="flex flex-col gap-[5px] w-[49%]">
                            <label className="text-black capitalize">Coupon Name:</label>
                            <input 
                                type="text"
                                name="coupon_name"
                                value={formData.coupon_name}
                                onChange={handleChange}
                                className={`px-[15px] py-[7px] outline-none border-2 ${
                                    errors.coupon_name ? 'border-red-500' : 'border-[#1485a6]'
                                } rounded-[4px] text-black bg-[#eeeeee6e]`}
                                placeholder="Enter coupon name"
                            />
                            {renderError('coupon_name')}
                        </div>

                        <div className="flex flex-col gap-[5px] w-[49%]">
                            <label className="text-black capitalize">Coupon Code:</label>
                            <input 
                                type="text"
                                name="coupon_code"
                                value={formData.coupon_code}
                                onChange={handleChange}
                                className={`px-[15px] py-[7px] outline-none border-2 ${
                                    errors.coupon_code ? 'border-red-500' : 'border-[#1485a6]'
                                } rounded-[4px] text-black bg-[#eeeeee6e]`}
                                placeholder="Enter coupon code"
                            />
                            {renderError('coupon_code')}
                        </div>

                        <div className="flex flex-col gap-[5px] w-[49%]">
                            <label className="text-black capitalize">Discount Value:</label>
                            <input 
                                type="number"
                                name="coupon_discount"
                                value={formData.coupon_discount}
                                onChange={handleChange}
                                className={`px-[15px] py-[7px] outline-none border-2 ${
                                    errors.coupon_discount ? 'border-red-500' : 'border-[#1485a6]'
                                } rounded-[4px] text-black bg-[#eeeeee6e]`}
                                placeholder="Enter discount value"
                            />
                            {renderError('coupon_discount')}
                        </div>

                        <div className="flex items-center gap-[10px]">
                            <div className="flex flex-col gap-[5px] w-[25%]">
                                <label className="text-black capitalize">Start Date:</label>
                                <input
                                    type="date"
                                    name="coupon_start_date"
                                    value={formData.coupon_start_date}
                                    onChange={handleChange}
                                    className={`px-[15px] py-[7px] outline-none border-2 ${
                                        errors.coupon_start_date ? 'border-red-500' : 'border-[#1485a6]'
                                    } rounded-[4px] text-black bg-[#eeeeee6e]`}
                                />
                                {renderError('coupon_start_date')}
                            </div>

                            <div className="flex flex-col gap-[5px] w-[25%]">
                                <label className="text-black capitalize">End Date:</label>
                                <input
                                    type="date"
                                    name="coupon_end_date"
                                    value={formData.coupon_end_date}
                                    onChange={handleChange}
                                    className={`px-[15px] py-[7px] outline-none border-2 ${
                                        errors.coupon_end_date ? 'border-red-500' : 'border-[#1485a6]'
                                    } rounded-[4px] text-black bg-[#eeeeee6e]`}
                                />
                                {renderError('coupon_end_date')}
                            </div>
                        </div>

                        <div className="flex items-center gap-[10px] mt-4">
                            <button 
                                type="submit" 
                                disabled={isSubmitting}
                                className="btn flex items-center gap-[5px] bg-[#1485a6] text-white px-4 py-2 rounded hover:bg-[#106c89] disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <AddIcon />
                                <span>{isSubmitting ? 'Adding...' : 'Add Coupon'}</span>
                            </button>
                            <button 
                                type="button"
                                onClick={handleReset}
                                className="btn bg-red-500 hover:bg-red-600 flex items-center gap-2 text-white px-4 py-2 rounded"
                            >
                                Reset
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    );
}